export class SiamFailure {
    static NO_REMAINING_PIECE_TO_INSERT = () => $localize `You cannot insert a piece, all your pieces are already on the board.`;
    static NOT_ENOUGH_FORCE_TO_PUSH = () => $localize `You do not have enough strength to push.`;
    static MUST_MOVE_OR_ROTATE = () => $localize `You must move or rotate your piece.`;
    static ILLEGAL_PUSH = () => $localize `Your push is invalid: it is either not straight, is not pushing anything, or is leaving the board.`;
    static MUST_SELECT_VALID_DESTINATION = () => $localize `You must select a valid destination (highlighted on the board) for your piece`;
    static MUST_SELECT_ORIENTATION = () => $localize `You should select the orientation of your piece by clicking on one of the arrows.`;
}
